<!--
  Copyright (c) 2025-2026 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->
<div class="toolbar-container">
  <div class="toolbar">
    <label for="groupBy">Group By:</label>
    <select id="groupBy" class="small-input" (change)="onGroupByChange($event.target.value)">
      <option value="role">Role</option>
      <option value="region">Region</option>
    </select>

    @if (groupByField != 'role') {
      <label for="filterByRole">Filter By Role:</label>
      <select id="filterByRole" class="small-input" (change)="onFilterByChange($event.target.value, 'role')">
        <option value="">--</option>
        @for (option of allRoles; track option) {
          <option [ngValue]="option">{{ option }}</option>
        }
      </select>
    }

    @if (groupByField != 'region') {
      <label for="filterByRegion">Filter By Region:</label>
      <select id="filterByRegion" class="small-input" (change)="onFilterByChange($event.target.value, 'region')">
        <option value="">--</option>
        @for (option of allRegions; track option) {
          <option [ngValue]="option">{{ option }}</option>
        }
      </select>
    }

    <label for="startLabel">Start:</label>
    <select id="startLabel" class="small-input" [ngModel]="allLabels[startLabelIndex]" (change)="onStartChange($event.target.value)">
      <option value="">--</option>
      @for (option of startLabels; track option) {
        <option>{{ option }}</option>
      }
    </select>

    <label for="endLabel">End:</label>
    <select id="endLabel" class="small-input" (change)="onEndChange($event.target.value)">
      <option value="">--</option>
      @for (option of endLabels; track option) {
        <option>{{ option }}</option>
      }
    </select>

    <label for="showLine">Show Line:</label>
    <input id="showLine" type="number" class="small-input" (change)="onShowLineChange($event.target.value)" />
  </div>
</div>


<svg [attr.width]="width" [attr.height]="height">
  <!-- Draw x-axis -->
  <line [attr.x1]="50"
    [attr.y1]="height - 50"
    [attr.x2]="width - 50"
    [attr.y2]="height - 50"
  stroke="black"></line>

  <!-- Draw y-axis -->
  <line [attr.x1]="50"
    [attr.y1]="50"
    [attr.x2]="50"
    [attr.y2]="height - 50"
  stroke="black"></line>

  <!-- Draw stacked bars -->
  @for (bar of bars; track bar) {
    <g>
      @for (group of bar.groups; track group) {
        <rect
          [attr.x]="bar.x"
          [attr.y]="group.y"
          [attr.width]="group.width"
          [attr.height]="group.height"
          [attr.fill]="group.color"
          (mouseenter)="showTooltip($event, group, bar)"
        (mouseleave)="hideTooltip()"></rect>
      }
      @if (bar.groups[0]) {
        <text
          [attr.x]="bar.x + (bar.groups[0].width / 2)"
          [attr.y]="bar.groups[bar.groups.length - 1].y - 2"
          text-anchor="middle"
          font-size="10">
          {{ getTotalHeight(bar.groups) }}
        </text>
      }
    </g>
  }

  @if (bars.length === 0) {
    <text
      [attr.x]="width / 2"
      [attr.y]="height / 2"
      text-anchor="middle"
      font-size="14"
      fill="gray">
      No data available
    </text>
  }

  @if (showLine) {
    <line
      [attr.x1]="50"
      [attr.y1]="showLineY"
      [attr.x2]="width - 50"
      [attr.y2]="showLineY"
    stroke="red"></line>
  }
  @if (showLine) {
    <text
      [attr.x]="width - 50"
      [attr.y]="showLineY"
      text-anchor="start"
    font-size="10" fill="red">{{showLine}}</text>
  }

  <!-- Draw x-axis labels -->
  @for (label of xAxisLabels; track label) {
    <text
      [attr.x]="label.x"
      [attr.y]="height - 30"
      text-anchor="middle"
      font-size="10">
      {{ label.label }}
    </text>
  }

  <!-- Draw y-axis labels -->
  @for (y of [0, maxWorkload / 4, maxWorkload / 2, (maxWorkload * 3) / 4, maxWorkload]; track y) {
    <g>
      <text [attr.x]="40"
        [attr.y]="height - 50 - (y / maxWorkload) * (height - 100)"
        text-anchor="end"
        font-size="10">
      {{ y | number }}</text>
      <line
        [attr.x1]="50"
        [attr.y1]="height - 50 - (y / maxWorkload) * (height - 100)"
        [attr.x2]="width - 50"
        [attr.y2]="height - 50 - (y / maxWorkload) * (height - 100)"
      stroke="gray" opacity=".3"></line>
    </g>
  }
</svg>
@if (tooltip.visible) {
<div [style]="{position: 'absolute', border: 'black 1px solid', backgroundColor: currentGroup.color,
 top: tooltip.y + 'px', left: tooltip.x + 'px', whiteSpace: 'pre-line'}">
    <div [style]="{backgroundColor: 'rgba(255,255,255,0.5)', paddingLeft: '5px', paddingRight: '5px'}">{{tooltip.text}}</div>
  </div>
}
<div class="legend">
  @for (group of groupKeys; track group) {
    <div class="legend-item">
      <span [style.backgroundColor]="colors[group]" class="legend-color"></span>
      {{ group }}
    </div>
  }
</div>
